import { adminActionTypes } from "src/action_types/section_action_types";

export function selectedPatientTablePageLimitReducer(state = 25, action) {
  switch (action.type) {
    case adminActionTypes.selectPatientTablePageLimit:
      return action.payload;
    case adminActionTypes.selectOrganizations:
      return 25;
    case adminActionTypes.deselectOrganizations:
      return 25;
    case adminActionTypes.selectFacilities:
      return 25;
    case adminActionTypes.deselectFacilities:
      return 25;
    case adminActionTypes.selectedPartner:
      return 25;
    default:
      return state;
  }
}
